<div class="screen-container" [class.handset-screen-container]="isHandset$ | async">
  <div class="internal-spinner" *ngIf="state === 'loading'">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>
  <div *ngIf="state === 'error'" class="mobile-central-content flex-column-center">
    <mat-card class="mobile-card-content">
      <div class="warning-icon">⚠️</div>
      <div class="warning-label">{{errMsg}}</div>
    </mat-card>
  </div>
  <div id="liqpay_checkout" *ngIf="state === 'show_booking_widget'" class="mobile-central-content has-tcs-row"></div>
  <div *ngIf="state === 'show_booking_widget'" class="flex-column-center flex-justify-center booking-tcs-row">
    <div [innerHTML]="'booking_tcs' | GetLabelPipe">
    </div>
  </div>

  <div class="messenger-button-container">
    <button type="submit" class="messenger-button" mat-raised-button color="accent"
            (click)="exit()" id="exit_button">
      {{exitLabel}}
    </button>
  </div>
</div>

